// extracted by mini-css-extract-plugin
module.exports = {"text":"text__xIhp6"};